import script from "./AppStage.vue?vue&type=script&setup=true&lang=js"
export * from "./AppStage.vue?vue&type=script&setup=true&lang=js"

import "./AppStage.vue?vue&type=style&index=0&id=22ff159d&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22ff159d"]])

export default __exports__